import { render, staticRenderFns } from "./ResourceList.vue?vue&type=template&id=6de12234"
import script from "./ResourceList.vue?vue&type=script&lang=js"
export * from "./ResourceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports